var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "sortable-list"
    },
    [
      _vm.filters.filter_loading_status
        ? _c("v-progress-linear", {
            attrs: {
              indeterminate: true
            }
          })
        : _vm._e(),
      _vm.filters.filters_loading_status
        ? _c("v-progress-linear", {
            attrs: {
              indeterminate: true
            }
          })
        : _vm.filters_data.length !== 0
        ? _c(
            "draggable",
            {
              on: {
                sort: _vm.reorderFilter
              },
              model: {
                value: _vm.filters_data,
                callback: function callback($$v) {
                  _vm.filters_data = $$v
                },
                expression: "filters_data"
              }
            },
            [
              _c(
                "transition-group",
                _vm._l(_vm.filters_data, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: "k-".concat(index),
                      staticClass: "sortable-item"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sortable-inner"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "sortable-icon"
                            },
                            [
                              _c("v-icon", [
                                _vm._v("mdi-unfold-more-horizontal")
                              ])
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "sortable-name"
                            },
                            [_vm._v(" " + _vm._s(item.filtername) + " ")]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "sortable-actions"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                icon: ""
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.getFilter(
                                    _vm.account,
                                    item.filtername
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: "primary"
                                  }
                                },
                                [_vm._v("mdi-pencil")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                icon: ""
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.openDeleteModal(
                                    _vm.account,
                                    item.filtername
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: "primary"
                                  }
                                },
                                [_vm._v("mdi-delete")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "text-center"
            },
            [_vm._v(" No filters found ")]
          ),
      [
        _c(
          "v-dialog",
          {
            attrs: {
              "max-width": "500px"
            },
            model: {
              value: _vm.modal,
              callback: function callback($$v) {
                _vm.modal = $$v
              },
              expression: "modal"
            }
          },
          [
            _vm.modal
              ? _c("delete-modal", {
                  attrs: {
                    account: _vm.account,
                    filtername: _vm.filtername
                  },
                  on: {
                    close: _vm.closeDeleteModal
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }